<div class="minicart-wrapper">
  <div class="minicart d-flex flex-column">
    <div class="px-sm-6 px-3 pb-3 pb-ms-4 pt-sm-6 pt-4">
      <div class="d-flex flex-row justify-content-between">
        <h4 class="mb-0 text-black">Your Bag</h4>
        <img (click)="close()" height="24" width="24" src="/assets/close.svg" />
      </div>
      <app-motivator
        *ngIf="_config && checkout?.lines?.edges?.length"
        [config]="_config"
        [cart]="checkout"
      >
      </app-motivator>
    </div>
    <div class="items p-6" *ngIf="checkout?.state === 'loading'">
      <div
        class="d-flex justify-content-center align-items-center flex-column h-100"
      >
        <div class="h3">Loading Bag...</div>
      </div>
    </div>
    <div class="wrapper d-flex flex-column">
      <!-- Normal cart view -->
      <div
        class="items px-sm-6 px-3 mb-auto"
        *ngIf="checkout?.state !== 'loading' && !showGiftBag"
      >
        <div
          class="d-flex justify-content-center align-items-center flex-column h-100"
          *ngIf="!checkout?.lines?.edges?.length"
        >
          <div class="h3 border-bottom text-center pb-3 mb-3">Go Shopping!</div>
          <p>No items in Bag</p>
        </div>
        @defer (on idle; when true) {
        <app-lineitem
          class="mb-3 pb-3 d-flex"
          [lineItem]="item.node"
          [ngClass]="{ 'border-bottom': !last }"
          *ngFor="let item of checkout?.lines?.edges; let last = last"
        ></app-lineitem>
        } @placeholder {
        <div></div>
        }
      </div>
      <!-- Gift bag selection view -->
      <div
        class="px-3 py-3"
        *ngIf="
          checkout?.state !== 'loading' &&
          _upsells?.length > 0 &&
          checkout?.lines?.edges?.length &&
          showGiftBag
        "
      >
        <button class="btn btn-link p-0 mb-3" (click)="showGiftBag = false">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            class="me-1"
          >
            <path
              d="M15 18l-6-6 6-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back to cart
        </button>
        <h4>Make it gift ready!</h4>
        <p>
          Add our quality cotton drawstring bag, made with love. Fits up to 4
          cups or 2 large bottles.<br />
          Items packed separately. Swing tag included.
        </p>
        <div class="row">
          <app-upsell-item
            class="col-6 col-lg-5"
            *ngFor="let product of _upsells"
            [product]="product"
          ></app-upsell-item>
        </div>
      </div>
    </div>
    <div
      class="actions px-3 pb-3 pt-2 p-sm-6"
      *ngIf="checkout?.lines?.edges?.length"
    >
      <div class="subtotal mb-2 d-flex justify-content-between flex-row">
        <div class="label fw-bold">Subtotal</div>
        <div class="value fw-bold">
          {{ checkout?.cost?.subtotalAmount?.amount | currency }}
        </div>
      </div>
      <!-- Add Gift Bag button -->
      <button
        class="btn btn-outline-dark w-100 py-3 mb-2"
        *ngIf="_upsells?.length > 0 && _showUpsells && !showGiftBag"
        (click)="showGiftBag = true"
      >
        Add Gift Bag
      </button>
      <a
        id="checkout"
        class="btn checkout btn-dark py-3 w-100"
        [href]="checkout?.checkoutUrl"
      >
        Checkout
      </a>
    </div>
  </div>
</div>
<div class="bg" (click)="clickedOutside($event)"></div>
